import {EnumType, JacksonType, JsonIdentityInfo, JsonSubType} from "@sonner/jackson-service-v2";
import {AlertaFiscal} from "./alerta.fiscal";
import {PapelServicoEnum} from "../enums/papel.servico.enum";

@JacksonType("AlertaFiscalQuedaArrecadacao")
@JsonSubType({key: 'br.com.sonner.iss.entity.dw.AlertaFiscalQuedaArrecadacao', type: 'AlertaFiscal'})
@JsonIdentityInfo()
export class AlertaFiscalQuedaArrecadacao extends AlertaFiscal {

  @EnumType(PapelServicoEnum)
  papel: PapelServicoEnum;

  valorMedio: number;

  valorReceita: number;
}
